module.exports = __webpack_public_path__ + "static/media/beepbeep.6e9c8f96.mp3";